import { Box, Button, Container, Drawer, Typography } from "@material-ui/core";
import React, { useState } from "react";
import Cover from "./Cover";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  heading: {
    marginTop: "2em",
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "1em",
  },
  warningBox: {
    padding: "10px",
    border: "2px solid red",
    borderRadius: "4px",
  },
  warningText: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "red",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
}));
export default function ResetWarning({
  setResetDrawer,
  setReset,
  user,
  handleRefresh,
  setViewDetailsDrawer,
}) {
  const classes = useStyles();
  const handleConfirm = () => {
    setResetDrawer(false);
    setReset((prev) => !prev);
  };
  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Cover
        profilePic={user?.profile_pic}
        handleRefresh={handleRefresh}
        user={user}
        setViewDetailsDrawer={setViewDetailsDrawer}
      />
      <Container
        style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography className={classes.heading}>Warning</Typography>
        <Box className={classes.warningBox}>
          <Typography className={classes.warningText}>
            Permission change: You are changing the permissions to default. Team
            member may gain access to some areas of the application. You can't
            reverse this process.
          </Typography>
        </Box>
        <Box className={classes.buttonContainer}>
          <Button
            size="small"
            variant="contained"
            disableElevation
            onClick={() => setResetDrawer(false)}
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            className={classes.btnPrimary}
            variant="contained"
            size="small"
            //   color="primary"
            style={{
              textTransform: "none",
              backgroundColor: "#286acf",
              color: "#fff",
            }}
            // onClick={() => setResetDrawer(false)}
            onClick={handleConfirm}
          >
            Confirm changes
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
